
// Components
const Account = () => import('@component/user-backend/Account.vue');
const Dashboard = () => import('@component/user-backend/Account/Dashboard.vue');

const OrderList = () => import('@component/user-backend/Account/OrderList.vue');
const Order = () => import('@component/user-backend/Account/Order.vue');
const Subscription = () => import('@component/user-backend/Account/Subscription.vue');

const SubscriptionList = () => import('@component/user-backend/Account/SubscriptionList.vue');
const AddressList = () => import('@component/user-backend/Account/AddressList.vue');
const EditAddress = () => import('@component/user-backend/Account/EditAddress.vue');

const AccountDetails = () => import('@component/user-backend/Account/Details.vue');

const UpdatePayment = () => import('@component/user-backend/Account/UpdatePayment.vue');

// Routes
export default {
  path: '/my-account',
  component: Account,
  children: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: 'orders',
			name: 'orders',
      component: OrderList
    },
    {
      path: 'view-subscription/:id',
			name: 'view-subscription',
      component: Subscription,
      props: true
    },
    {
      path: 'addresses',
			name: 'addresses',
      component: AddressList
    },
    {
      path: 'account-details',
			name: 'account-details',
      component: AccountDetails
    },
    {
      path: 'view-order/:id',
			name: 'view-order',
      component: Order,
      props: route => ({ 
        order: null, // Will be loaded by the component
        id: route.params.id 
      })
    },
    {
      path: 'edit-address/:id/:type',
			name: 'edit-address',
      component: EditAddress,
      props: true
    },
    {
      path: 'subscriptions',
			name: 'subscriptions',
      component: SubscriptionList
    },
		{
			path: 'update-payment',
			name: 'update-payment',
			component: UpdatePayment
		},
    {
      path: '*',
			name: 'my-account',
      redirect: '/my-account'
    }
  ]
};
